<template>

    <div class="image-container">
        <img :src="require('@/assets/picture-1.png')" alt="Project Image">
        <p><b>Citation:</b> Jiarong Chen, Yanlei Feng, Yuchan Zhang, Jinda Qu, Weiyin Wu, Can li, Shuyan Song, Li Tai, Mahmudul Hasan Rifat, Jianping Hu, Peiqiang Feng, Xing-Xing Shen, Ronghui Pan, Structure-guided Discovery of Novel Protein Functions in Plants. In Preparation.</p>
    </div>
    <footer>
        <!-- 添加两个图片 -->
        <div class="footer-images">
        <img :src="require('@/assets/picture-2.jpg')" alt="Footer Image 1" class="footer-image">
        <img :src="require('@/assets/picture-3.png')" alt="Footer Image 2" class="footer-image">
        </div>
        <div class="footer-link">
        Visit the homepage of the lab: <a href="https://person.zju.edu.cn/en/panr" target="_blank">https://person.zju.edu.cn/en/panr</a>
        </div>
    </footer>

</template>

<style scoped>
.image-container img {
  max-width: 100%;
  height: auto;
}

footer {
  margin-top: auto; /* 将footer推到页面底部 */
  margin-bottom: 20px; /* 设置footer距离页面底部的距离 */
}

footer a {
  color: blue;
}

.footer-images img {
  margin-top: 10px;
  max-width: 100%;
  height: 80px;
}

.footer-image {
  margin-right: 50px; 
}

.footer-link {
  margin-top: 20px; 
}

.footer-images img:last-child {
  margin-right: 0;
}
</style>